/* ============================================================================
   cart-drawer.js — comportamiento del cajón del carrito (1028).
   Reescrito de cero: sustituye al archivo de Zendrop.

   Todo vive dentro de un IIFE: este archivo NO declara ni una sola variable
   global. El original declaraba `formatMoney` y `debounce` sueltos y pisaba los
   de global.js (Dawn) y los de secondary.js — de ahí venían roturas raras.

   Contrato público del elemento <cart-drawer> (lo usan archivos que no tocamos,
   NO renombrar):
     open(disparador) / close()          product-form.js, botones del tema
     renderContents(respuesta)           product-form.js al añadir al carrito
     setActiveElement(elemento)          product-form.js (a dónde vuelve el foco)
     getSectionsToRender()               product-form.js lee el .id de cada uno
     getSectionInnerHTML(html, sel)
     updateCart()                        snippets/upsell-1028.liquid y
                                         snippets/warranty-toggle-1028.liquid
     evento 'cartUpdated' (burbujea)

   Globales de Dawn que se usan si existen (nunca se asumen):
     routes, trapFocus, removeTrapFocus, onKeyUpEscape, CartItems.

   Los clics se escuchan UNA vez en el propio <cart-drawer> (delegación). Antes
   se re-enganchaban a mano tras cada repintado, con un setTimeout de 1s de por
   medio; ahora el interior se puede repintar las veces que haga falta sin que
   se pierda ningún manejador.
   ========================================================================= */
(function () {
  'use strict';

  var SECTION_ID = 'cart-drawer';
  var SEL_INNER = '.drawer__inner';
  var SEL_FOOTER = '.cart-drawer__footer';
  var ID_OVERLAY = 'CartDrawer-Overlay';
  var SEL_UPSELL_ITEM = '.ct-cart-upsell__item';
  var SEL_UPSELL_ADD = '.ct-cart-upsell__add';
  var SEL_UPSELL_VARIANTS = '.ct-cart-upsell__variants';

  /** URL de una ruta del carrito, con respaldo por si `routes` no llegó. */
  function cartRoute(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  /** Devuelve el interior de `selector` dentro de un trozo de HTML suelto. */
  function innerHTMLOf(html, selector) {
    if (!html) return null;
    var found = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return found ? found.innerHTML : null;
  }

  var CtCartDrawer = class extends HTMLElement {
    constructor() {
      super();

      // lo consulta addUpsellToCart para no pisar una recarga en curso
      this.isCartUpdating = false;
      this.activeElement = null;

      this.addEventListener('keyup', function (event) {
        if (event.code === 'Escape') this.close();
      }.bind(this));

      // delegación: sobrevive a cualquier repintado del interior del cajón
      this.addEventListener('click', this.onDrawerClick.bind(this));
      this.addEventListener('change', this.onDrawerChange.bind(this));
      this.addEventListener('submit', this.onDrawerSubmit.bind(this));

      this.bindCartIcon();
    }

    /* ---------- apertura y cierre ---------- */

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);

      var note = this.querySelector('[id^="Details-"] summary');
      if (note && !note.hasAttribute('role')) this.makeSummaryAccessible(note);

      // el navegador necesita un tick para que la transición arranque
      setTimeout(
        function () {
          this.classList.add('animate', 'active');
        }.bind(this)
      );

      this.addEventListener(
        'transitionend',
        function () {
          var container = this.classList.contains('is-empty')
            ? this.querySelector('.drawer__inner-empty')
            : this.querySelector('#CartDrawer');
          var focusTarget = this.querySelector(SEL_INNER) || this.querySelector('.drawer__close');
          if (container && focusTarget && typeof trapFocus === 'function') {
            trapFocus(container, focusTarget);
          }
        }.bind(this),
        { once: true }
      );

      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    /* ---------- eventos delegados ---------- */

    onDrawerClick(event) {
      // fondo oscuro: solo si el clic cae en él, no en algo de dentro
      if (event.target.id === ID_OVERLAY) {
        this.close();
        return;
      }

      if (event.target.closest('[data-ct-cart-close]')) {
        event.preventDefault();
        this.close();
        return;
      }

      var addButton = event.target.closest(SEL_UPSELL_ADD);
      if (addButton) {
        event.preventDefault();
        this.addUpsellToCart(addButton);
      }
    }

    onDrawerChange(event) {
      var select = event.target.closest(SEL_UPSELL_VARIANTS);
      if (select) this.syncUpsellVariant(select);
    }

    onDrawerSubmit(event) {
      // ojo: aquí también burbujea el submit del formulario del carrito
      // (botón de pagar). Solo se intercepta el del cupón.
      var form = event.target.closest('[data-ct-cart-discount]');
      if (!form) return;

      event.preventDefault();
      var field = form.querySelector('input[name="cart-discount-field"]');
      var code = field ? field.value.trim() : '';
      if (!code) return;

      window.location.href = '/checkout?discount=' + encodeURIComponent(code);
    }

    /* ---------- upsells del cajón ---------- */

    /** Cambia foto y variante elegida cuando el cliente usa el desplegable. */
    syncUpsellVariant(select) {
      var item = select.closest(SEL_UPSELL_ITEM);
      if (!item) return;

      var image = item.querySelector('.ct-cart-upsell__image');
      var option = select.options[select.selectedIndex];
      if (image && option) {
        var variantImage = option.getAttribute('data-image-url');
        var defaultImage = image.getAttribute('data-default-image');
        var usable = variantImage && variantImage.indexOf('no-image') === -1;
        var next = usable ? variantImage : defaultImage;
        if (next) image.src = next;
      }

      var addButton = item.querySelector(SEL_UPSELL_ADD);
      if (addButton) addButton.setAttribute('data-product-id', select.value);
    }

    /** Añade el upsell y repinta el cajón para que se vea la línea nueva. */
    addUpsellToCart(button) {
      if (this.isCartUpdating) return;

      var item = button.closest(SEL_UPSELL_ITEM);
      var select = item ? item.querySelector(SEL_UPSELL_VARIANTS) : null;
      // el data-product-id del botón ya guarda el id de la PRIMERA variante
      var variantId = (select && select.value) || button.getAttribute('data-product-id');

      if (!variantId) {
        console.error('[ct-cart] upsell sin id de variante');
        return;
      }

      button.disabled = true;

      fetch(cartRoute('cart_add_url', '/cart/add'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart/add ' + response.status);
          return response.json();
        })
        .then(
          function () {
            this.updateCart();
          }.bind(this)
        )
        .catch(function (error) {
          button.disabled = false;
          console.error('[ct-cart] no se pudo añadir el upsell:', error);
        });
    }

    /* ---------- repintado ---------- */

    /**
     * Recarga el cajón desde el servidor. Lo llaman upsell-1028 y
     * warranty-toggle-1028 después de tocar el carrito por su cuenta.
     * Pide SOLO la sección (?section_id=) en vez de la página /cart entera.
     */
    updateCart() {
      this.isCartUpdating = true;

      return fetch(cartRoute('cart_url', '/cart') + '?section_id=' + SECTION_ID)
        .then(function (response) {
          if (!response.ok) throw new Error('section ' + response.status);
          return response.text();
        })
        .then(
          function (html) {
            var fresh = new DOMParser().parseFromString(html, 'text/html');

            // el pie de totales viaja dentro de .drawer__inner; con repintar
            // el interior basta, pero si algún día saliera de ahí, se cubre.
            var regions = [SEL_INNER, SEL_FOOTER];
            for (var i = 0; i < regions.length; i++) {
              var target = this.querySelector(regions[i]);
              var source = fresh.querySelector(regions[i]);
              if (target && source && target.innerHTML !== source.innerHTML) {
                target.innerHTML = source.innerHTML;
              }
            }

            this.announceUpdate();
          }.bind(this)
        )
        .catch(function (error) {
          console.error('[ct-cart] no se pudo recargar el cajón:', error);
        })
        .finally(
          function () {
            this.isCartUpdating = false;
          }.bind(this)
        );
    }

    /** Lo llama product-form.js al añadir un producto desde la ficha. */
    renderContents(parsedState) {
      var inner = this.querySelector(SEL_INNER);
      if (inner) inner.classList.remove('is-empty');

      this.productId = parsedState ? parsedState.id : null;
      var sections = (parsedState && parsedState.sections) || {};

      this.getSectionsToRender().forEach(function (section) {
        var target = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!target) return;

        var html = innerHTMLOf(sections[section.id], section.selector || '.shopify-section');
        if (html !== null) target.innerHTML = html;
      });

      setTimeout(
        function () {
          this.open();
        }.bind(this)
      );

      this.announceUpdate();
    }

    getSectionsToRender() {
      return [
        { id: SECTION_ID, selector: SEL_INNER },
        { id: SECTION_ID, selector: SEL_FOOTER },
      ];
    }

    getSectionInnerHTML(html, selector) {
      return innerHTMLOf(html, selector || '.shopify-section');
    }

    /** Aviso para el resto del tema (barra de envío gratis, etc.). */
    announceUpdate() {
      this.dispatchEvent(new CustomEvent('cartUpdated', { bubbles: true }));
    }

    /* ---------- accesibilidad ---------- */

    /** El icono del carrito de la cabecera abre el cajón en vez de ir a /cart. */
    bindCartIcon() {
      var cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink) return;

      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');

      cartLink.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          this.open(cartLink);
        }.bind(this)
      );

      cartLink.addEventListener(
        'keydown',
        function (event) {
          if (event.code && event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.open(cartLink);
          }
        }.bind(this)
      );
    }

    /** El <summary> de la nota del pedido debe anunciarse como botón. */
    makeSummaryAccessible(summary) {
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-expanded', 'false');

      var panel = summary.nextElementSibling;
      if (panel && panel.id) summary.setAttribute('aria-controls', panel.id);

      summary.addEventListener('click', function (event) {
        var details = event.currentTarget.closest('details');
        event.currentTarget.setAttribute('aria-expanded', !(details && details.hasAttribute('open')));
      });

      if (summary.parentElement && typeof onKeyUpEscape === 'function') {
        summary.parentElement.addEventListener('keyup', onKeyUpEscape);
      }
    }
  };

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CtCartDrawer);
  }

  /* --------------------------------------------------------------------------
     <cart-drawer-items>: hereda de CartItems (assets/cart.js, de Dawn), que es
     quien maneja cantidades y borrados. Solo se le cambia qué trozos repintar.
     Si cart.js no se hubiera cargado todavía, se avisa y no se define nada: sin
     la guarda, el ReferenceError tumbaba el resto del archivo.
     ----------------------------------------------------------------------- */
  if (typeof CartItems === 'undefined') {
    console.warn('[ct-cart] cart.js no está cargado: <cart-drawer-items> no se registra');
  } else if (!customElements.get('cart-drawer-items')) {
    var CtCartDrawerItems = class extends CartItems {
      getSectionsToRender() {
        return [
          { id: 'CartDrawer', section: SECTION_ID, selector: SEL_INNER },
          { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
        ];
      }
    };

    customElements.define('cart-drawer-items', CtCartDrawerItems);
  }
})();
